import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type InvoiceCompanyFileFragment = { id: string, pk: number, fileUrl: string, type: string };

export const InvoiceCompanyFileFragmentDoc = gql`
    fragment InvoiceCompanyFileFragment on InvoiceCompanyFileType {
  id
  pk
  fileUrl
  type
}
    `;